
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[exchange]/[ticker]/corporate-actions/all",
      function () {
        return require("private-next-pages/s/[exchange]/[ticker]/corporate-actions/all/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[exchange]/[ticker]/corporate-actions/all"])
      });
    }
  